<template>
  <div>
    <div v-if="finished == false">
      <div
        style="background-color: #ccc"
        class="pb-2 mb-3"
      >
        <div class="container">
          <div class="row">
            <div class="col-lg-12 pt-3 col-12 col-sm-12">
              <KProgress
                :color="['#53358B', '#00baf7']"
                bg-color="#fff"
                :percent="percent"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="col-lg-12 col-lg-12">
          <h1
            class="mb-3"
            v-if="amount == 0"
          >
            Temos mais uma etapa para você!
          </h1>
          <p v-if="amount == 0">
            Queremos te conhecer melhor e por isso utilizamos uma ferramenta de
            assessment comportamental baseada na metodologia BigFive. O teste de
            assessment serve para mapear características do seu perfil.
          </p>

          <p v-if="amount == 0">
            A partir de agora você deverá responder uma sequência de perguntas
            sempre escolhendo a resposta que mais se adequa ao seu perfil. É
            rapido, você vai precisar de menos de 10 minutos.
          </p>

          <p v-if="amount == 0">
            Ao final do teste você terá acesso ao seu resultado e poderá fazer o
            download do relatório.
          </p>
          <br />
          <br />
        </div>
        <div class="col-lg-12 col-xs-12">
          <div v-if="questions.length == 0">
            <div
              class="spinner-border text-light"
              role="status"
            >
              <span class="sr-only"></span>
            </div>
          </div>
          <div v-if="answers.length < total_item_test">
            <div
              v-for="question in questions.slice(
                amount,
                amount + items_per_page
              )"
              :key="question.id"
            >
              <h3>{{ question.text }}</h3>
              <div
                v-for="(choice, i) in question.choices"
                :key="i"
              >
                <label @click="set_answer(question.id, choice.score)">
                  <input
                    type="radio"
                    :name="question.id"
                    :value="choice.score"
                  />
                  {{ choice.text }}
                </label>
              </div>
              <hr />
            </div>
          </div>
          <button
            :disabled="ableBtnSave()"
            v-if="answers.length < total_item_test"
            @click="next"
            class="mb-3 btn btn-degrade save_bigfive right normal-degrade"
          >
            Salvar
            <font-awesome-icon icon="chevron-right" />
          </button>

          <button
            v-if="answers.length == total_item_test"
            @click="save"
            type="button"
            class="btn btn-primary"
          >
            Calcular resultado do teste
          </button>
        </div>
      </div>
    </div>
    <div v-if="finished">
      <BigfiveShow
        :account_uid="account_uid"
        :candidate_uid="uid ? uid : candidate_uid"
        :no_next="no_next"
      />
    </div>
  </div>
</template>

<script>
import KProgress from "k-progress";
import BigfiveShow from "@/Bigfives/Show.vue";
export default {
  components: { KProgress, BigfiveShow },
  props: [
    "bigfive_uid",
    "amount_itens",
    "account_uid",
    "candidate_uid",
    "no_next",
  ],
  data: () => ({
    questions: [],
    amount: 0,
    answers: [],
    percent: 0,
    finished: false,
    items_per_page: 3,
    total_item_test: 120,
    uid: "",
  }),
  async mounted() {
    if (this.candidate_uid) {
      this.uid = this.candidate_uid;
      axios
        .get("/bigfive_candidates/" + this.candidate_uid)
        .then((response) => {
          if (response.data.id) {
            this.uid = response.data.candidate_uid;
            this.finished = true;
          }
        });
    }
    this.onResize();

    if (this.amount_itens == 120) {
      const { getItems, getInfo, getChoices, getQuestions } =
        await require("@alheimsins/b5-johnson-120-ipip-neo-pi-r");
      this.questions = getItems("pt-br", true);
      console.log(this.questions);
    } else {
      const { getItems } = await require("@alheimsins/b5-50-ipip-neo-pi-r");
      this.questions = getItems("pt-br");
      console.log(this.questions);
      this.total_item_test = 50;
    }
  },
  methods: {
    ableBtnSave() {
      if (this.answers.length == this.amount + this.items_per_page) {
        return false;
      }
      return true;
    },
    set_persent() {
      this.percent = Math.round(
        (this.answers.length * 100) / this.questions.length
      );
    },
    next() {
      window.scroll(0, 0);
      this.amount = this.amount + this.items_per_page;
    },
    save() {
      axios
        .post("/bigfive_candidates", {
          bigfive_candidates: {
            answers: this.answers,
          },
          bigfive_uid: this.bigfive_uid,
          account_uid: this.account_uid,
        })
        .then((response) => {
          this.uid = response.data.uid;
          this.finished = true;
        });
    },
    set_answer(id, score) {
      let answers_current = this.answers.find((q) => q.questionID === id);
      let question_current = this.questions.find((q) => q.id === id);
      if (answers_current) {
        answers_current.score = score;
        return;
      }
      this.answers.push({
        questionID: id,
        score: score,
        facet: question_current.facet,
        domain: question_current.domain,
      });
      this.set_persent();
    },
    onResize() {
      window.innerWidth < 600
        ? (this.items_per_page = 1)
        : (this.items_per_page = 3);
    },
  },
};
</script>

<style>
</style>